<template>
    <router-link :to="homeURL" id="logo">
        <img src="@/assets/img/ui/logo.png">
    </router-link>
</template>
<script>
export default {
    computed: {
        homeURL() {
            return app.api.PageManager.getRootPage().route
        }
    }
}
</script>
<style lang="scss" scoped>
    #logo {
        position: absolute;
        width: 262px;
        top: 70px;
        left: 60px;
        z-index: 2;
        padding: 10px 20px;
        cursor: pointer;
        
        &>img {
            width: 100%;
        }
    }
</style>